module.exports = __webpack_public_path__ + "static/media/ICONS-POWER_TRANSMISSION.09ca299d.svg";